<template>
  <ion-row class="heading">
    <h5 v-if="title">{{ title }}</h5>

    <div v-if="duration" class="report-week-total">
      {{ floatToString(duration, 'h') }}
    </div>
  </ion-row>

  <div class="report-component">
    <ion-row>
      <ion-item
        button
        :disabled="disabled"
        @click.stop="onItemClick('start')"
        class="ion-margin-end"
      >
        <ion-label v-if="placeholders && placeholders[0]" position="floating">
          {{ placeholders[0] }}
        </ion-label>
        <ion-label v-else position="floating">Début</ion-label>

        <ion-input
          :disabled="disabled"
          :value="formatForDisplay(start, selectedDay)"
          readonly
          tabindex="-1"
          class="no-pointer-events"
        ></ion-input>
      </ion-item>

      <ion-item button :disabled="disabled" @click.stop="onItemClick('end')">
        <ion-label v-if="placeholders && placeholders[1]" position="floating">
          {{ placeholders[1] }}
        </ion-label>
        <ion-label v-else position="floating">Fin</ion-label>

        <ion-input
          :disabled="disabled"
          :value="formatForDisplay(end, selectedDay)"
          readonly
          tabindex="-1"
          class="no-pointer-events"
        ></ion-input>
      </ion-item>
    </ion-row>
  </div>
</template>

<script>
import {
  IonItem,
  IonInput,
  IonRow,
  IonLabel,
  pickerController,
} from '@ionic/vue';
import { mixinReportComponentsCommon } from '@/components/driver/rentalCoupon/mixins/ReportComponentsCommon';
import utils from '@/services/utils/Utils';
import {
  generateFiveMinuteIntervals,
  floatToString,
} from '@/services/utils/dateUtils';

const dayjs = require('dayjs');
require('dayjs/locale/fr');
dayjs.locale('fr');

const POSSIBLE_MINUTES = generateFiveMinuteIntervals();

export default {
  name: 'DateRange',

  components: {
    IonItem,
    IonInput,
    IonRow,
    IonLabel,
  },

  mixins: [mixinReportComponentsCommon],

  props: {
    title: String,
    placeholders: Array,
    start: String,
    end: String,
    selectedDay: String,
    disabled: Boolean,

    dates: Object,
  },

  emits: ['update:start', 'update:end'],

  methods: {
    onItemClick(property) {
      this.setNow(property, this.selectedDay);

      this.$nextTick(() => {
        this.openPicker(property);
      });
    },

    // open picker is different than the mixin here because we need to handle 3 columns instead of one
    async openPicker(property) {
      const dates = Object.values(this.dates);

      // by default set date to midnight of the selected day
      let selectedDates = [dates.indexOf(this.selectedDay), 0, 0];
      if (this[property]) {
        // if already set date, re-use it
        const date = dayjs(this[property]);
        selectedDates = [
          dates.indexOf(date.format('YYYY-MM-DD')),
          date.hour().toString(),
          date.minute().toString(),
        ];
      }

      const mappedDays = Object.entries(this.dates).map(d => {
        return {
          text: d[0],
          value: d[1],
        };
      });

      const columns = [
        {
          name: 'day',
          options: mappedDays,
          selectedIndex: selectedDates[0],
          cssClass: 'hydrated',
        },
        ...utils.generatePickerColumns(
          selectedDates[1],
          selectedDates[2],
          POSSIBLE_MINUTES,
        ),
      ];

      columns[1].cssClass = 'hydrated';
      columns[2].cssClass = 'hydrated';

      const picker = await pickerController.create({
        columns,
        buttons: [
          {
            text: 'Supprimer',
            handler: () => {
              this.$emit(`update:${property}`, null);
            },
          },
          {
            text: 'Valider',
            handler: time => {
              const newDate = dayjs(time.day.value)
                .hour(time.hours.value)
                .minute(time.minutes.value)
                .toISOString();

              this.$emit(`update:${property}`, newDate);
            },
          },
        ],
      });

      await picker.present();
    },

    floatToString,
  },

  computed: {
    duration() {
      const minutes = dayjs(this.end).diff(dayjs(this.start), 'minute');

      // if invalid or negative duration
      if (isNaN(minutes) || minutes <= 0) return 0;

      return minutes / 60;
    },
  },
};
</script>

<style scoped lang="scss">
.heading {
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;

  .report-week-total {
    transform: scale(0.9);
  }
}
</style>
